import { render, staticRenderFns } from "./DocumentCompare.vue?vue&type=template&id=9d7aefb4&scoped=true"
import script from "./DocumentCompare.vue?vue&type=script&lang=js"
export * from "./DocumentCompare.vue?vue&type=script&lang=js"
import style0 from "./DocumentCompare.vue?vue&type=style&index=0&id=9d7aefb4&prod&scoped=true&lang=scss"
import style1 from "./DocumentCompare.vue?vue&type=style&index=1&id=9d7aefb4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d7aefb4",
  null
  
)

export default component.exports